import { Link } from "react-router-dom";
import MatchCard from "@/components/feature/MatchCard";
import { matches } from "@/mocks/matches";
import { todayStr, formatDateCN } from "@/utils";

export default function TodaySchedule() {
  const today = todayStr();
  const list = matches
    .filter((m) => m.date === today)
    .sort((a, b) => a.time.localeCompare(b.time));

  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5" data-product-shop>
      <div className="flex items-center justify-between gap-4 mb-4">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950">今日赛程</h2>
            <p className="text-xs text-foreground-500 mt-0.5">{formatDateCN(today)} · 共 {list.length} 场比赛</p>
          </div>
        </div>
        <Link to="/schedule" className="text-sm text-foreground-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer">
          全部赛程 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      {list.length === 0 ? (
        <div className="py-12 text-center text-foreground-400 flex flex-col items-center gap-3">
          <i className="ri-calendar-close-line text-4xl"></i>
          <p className="text-sm">今日暂无赛程安排</p>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {list.map((m) => (
            <MatchCard key={m.id} match={m} variant="row" />
          ))}
        </div>
      )}
    </div>
  );
}